<template>
  <div class="schedule-calendar-div">
    <div class="schedule-calendar-header" @click="backToday()">
      <van-grid :border="false" :column-num="7">
        <van-grid-item v-for="(item , index) in titleArray" :key="'titleitem' + index">
          <div class="header-text" :class="index == 0 || index == titleArray.length - 1 ? 'holiday-text' : 'normal-text'">{{item}}</div>
        </van-grid-item>
      </van-grid>
    </div>
    <div class="schedule-calendar-main">
      <div class="schedule-calendar-monthcontent" v-for="(item , index) in dataArray" :key="'monthItem' + index">
        <div v-if="item.year == currentYear && item.month == currentMonth" class="current-monthcontent-title">{{item.year}}年{{item.month}}月</div>
        <div v-else class="normal-monthcontent-title">{{item.year}}年{{item.month}}月</div>
        <div v-for="(weekItem , weekIndex) in item.data" :key="'dayItem' + weekIndex" :class="weekIndex == item.data.length - 1 ? 'monthcontent-lastweek' : 'monthcontent-week'">
          <van-grid :border="false" :column-num="7">
            <van-grid-item v-for="(dayItem , tempIndex) in weekItem" :key="'dayItem' + tempIndex" class="monthcontent-day" @click="jumpDate(item.year,item.month,dayItem.gregorian,dayItem.hasCourse)">
              <div v-if="dayItem.isToday" id="monthcontent-todaybackground-div" class="monthcontent-todaybackground-div"></div>
              <div v-if="dayItem.isToday" class="todaynumber-text">{{dayItem.gregorian}}</div>
              <div v-else class="daynumber-text" :class="tempIndex == 0 || tempIndex == weekItem.length - 1 ? 'holiday-text' : 'normal-text'">{{dayItem.gregorian}}</div>
              <div v-if="dayItem.isToday" class="todayoldday-text">{{dayItem.lunar}}</div>
              <div v-else class="oldday-text" :class="tempIndex == 0 || tempIndex == weekItem.length - 1 ? 'holiday-text' : 'normal-text'">{{dayItem.lunar}}</div>
              <div :class="dayItem.hasCourse ? 'dayitem-hascourse' : 'dayitem-nocourse'"></div>
            </van-grid-item>
          </van-grid>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfMobileScheduleCalendar",
  ctrlCaption: "日历组件",
  mixins: [$mixins.control],
  components: {},
  design: {
    isMask: false,
  },
  data() {
    return {
      titleArray: ["日", "一", "二", "三", "四", "五", "六"],
      dataArray:[],
      currentYear:0,
      currentMonth:0,
      currentDate:0,
      startDate:"",
      endDate:"",
      hasCourseDataArray:[],
      isContainToday: false,
      classId: "",
      isTeacher: false,
    };
  },
  props: {},
  created() {
    this.classId = this.queryString.classId || "";
    if(this.classId.length > 0){
      this.isTeacher = true;
    }else{
      this.isTeacher = false;
      this.classId = dsf.getCookie("class_id") || "";
    }
    let currentDate = new Date();
    this.currentYear = currentDate.getFullYear();
    this.currentMonth = currentDate.getMonth() + 1;
    this.currentDate = currentDate.getDate();
    if(this.isDesign){
      this.dataArray.push(this.getDays(2021, 4));
      this.dataArray.push(this.getDays(2021, 5));
      this.$dispatch("design-width-change", "100%");
    }else{
      this.loadCalendarTime();
    }
  },
  mounted() {},
  computed: {},
  methods: {
    // 获取当前月份所有公历日期及其农历日期
    getDays(year, month) {
      let days = [];
      const time = new Date();
      time.setFullYear(year, month, 0);

      let totalDay = time.getDate();
      const firstDay = new Date(year, month - 1, 1); // 当月第一天
      const lastDay = new Date(year, month - 1, totalDay); // 当月最后

      // 获取星期中的第几天（0-6）(星期日-星期六)
      let weekIndex = firstDay.getDay();

      let currentIndex = -1;
      if(this.currentYear == year && this.currentMonth == month){
        currentIndex = this.currentDate;
      }

      let _time = year + "-" + (month < 10 ? "0" + month : month);

      const lastWeekIndex = lastDay.getDay();
      let tempArr = [];
      for (let i = 1; i <= totalDay; i++) {
        if (i == 1 && weekIndex != 0) {
          for (let temp = 0; temp < weekIndex; temp++) {
            tempArr.push({ gregorian: "", lunar: "", hasCourse: false, isToday: false });
          }
        }
        let arrangeTime = _time + "-" + (i < 10 ? "0" + i : i);
        if(this.hasCourseDataArray.indexOf(arrangeTime) > - 1){
          if(currentIndex > 0 && currentIndex == i){
            tempArr.push({
              gregorian: i,
              lunar: dsf.date.getYearMonthDay(year, month, i),
              hasCourse: true,
              isToday: true,
            });
          }else{
            tempArr.push({
              gregorian: i,
              lunar: dsf.date.getYearMonthDay(year, month, i),
              hasCourse: true,
              isToday: false,
            });
          }
        }else{
          if(currentIndex > 0 && currentIndex == i){
            tempArr.push({
              gregorian: i,
              lunar: dsf.date.getYearMonthDay(year, month, i),
              hasCourse: false,
              isToday: true,
            });
          }else{
            tempArr.push({
              gregorian: i,
              lunar: dsf.date.getYearMonthDay(year, month, i),
              hasCourse: false,
              isToday: false,
            });
          }
        }
        if (i == totalDay && lastWeekIndex != 6) {
          for (let temp = 0; temp < 6 - lastWeekIndex; temp++) {
            tempArr.push({ gregorian: "", lunar: "", hasCourse: false, isToday: false });
          }
        }
        if (tempArr.length == 7) {
          let weekArray = tempArr;
          days.push(weekArray);
          tempArr = [];
        }
      }
      return {
          year : year,
          month : month,
          data : days,
      };
    },
    loadCalendarTime() {
      if(this.isDesign){
        return;
      }
      const loading = dsf.layer.loading();
      let _this = this;
      this.$http
        .get("classes/getTrainingTimeByClassId", {
          classId: this.classId || "",
        })
        .done((res) => {
          dsf.layer.closeLoading(loading);
          if (res.success) {
            _this.startDate = res.data.startData || "";
            _this.endDate = res.data.endData || "";
            _this.loadCurrentData();
          } else {
            dsf.layer.message(res.message || "请求失败", false);
          }
        })
        .error((err) => {
          dsf.layer.closeLoading(loading);
          dsf.layer.message(err.message || "出错了，请重试", false);
        });
    },
    loadCurrentData() {
      if(this.isDesign){
        return;
      }
      const loading = dsf.layer.loading();
      let urlString = "";
      let params = {};
      if(this.isTeacher){
        urlString = "teas/schedule/course/arrange/getClassCourseByTime";
        params = {
          stime: this.startDate,
          etime: this.endDate,
          isnum: true,
          classId: this.classId,
        };
      }else{
        urlString = "teas/schedule/course/arrange/getStuCourseByTime";
        params = {
          stime: this.startDate,
          etime: this.endDate,
          isnum: true,
        };
      }
      let _this = this;
      this.$http
        .get(urlString, params)
        .done((res) => {
          dsf.layer.closeLoading(loading);
          if (res.success) {
            let tempDataObject = res.data || {};
            _this.hasCourseDataArray = Object.keys(tempDataObject) || [];
            _this.getDayData();
          } else {
            dsf.layer.message(res.message || "请求失败", false);
          }
        })
        .error((err) => {
          dsf.layer.closeLoading(loading);
          dsf.layer.message(err.message || "出错了，请重试", false);
        });
    },
    getDayData(){
      let tempDate = new Date();
      let tempSDate = new Date(this.startDate.replace(/\-/g, "/"));
      let tempEDate = new Date(this.endDate.replace(/\-/g, "/"));
      if(tempDate >= tempSDate && tempDate <= tempEDate){
        this.isContainToday = true;
      }else{
        this.isContainToday = false;
      }
      let yearCount = tempEDate.getFullYear() - tempSDate.getFullYear();
      let monthCount = 12 * yearCount + tempEDate.getMonth() - tempSDate.getMonth() + 1;
      for(let i = 0; i < monthCount; i ++){
        let tempYear = tempSDate.getFullYear();
        let tempMonth = tempSDate.getMonth() + 1 + i;
        if(tempMonth > 12){
          tempYear = tempYear + parseInt(tempMonth) / 12;
          tempMonth = parseInt(tempMonth) % 12;
        }
        this.dataArray.push(this.getDays(parseInt(tempYear), tempMonth));
      }
    },
    backToday(){
        if(this.isContainToday){
          document.getElementById('monthcontent-todaybackground-div').scrollIntoView({block:"center"});
        }
    },
    jumpDate(year,month,day,hasCourse){
      if(hasCourse){
        let timeString = year + "-" + (parseInt(month) < 10 ? "0" + month : month) + "-" + (parseInt(day) < 10 ? "0" + day : day);
        localStorage.setItem("changeDate", timeString);
        this.$router.go(-1);
      }
    }
  },
});
</script>
<style lang="scss">
</style>
